import { type FC, useCallback, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { TextField } from '@/components/ui/text-field'

const FIELD_ID = 'customer-name'

interface Props {
  isOpen: boolean
  onClose: () => void
  onCreate: (listName: string) => void
  placeholder: string
  title: string
  description: string
}

export const CreateSpendingCustomerList: FC<Props> = ({
  isOpen,
  title,
  description,
  onClose,
  onCreate,
  placeholder,
}) => {
  const [listName, setListName] = useState('')

  const handleClose = useCallback(() => {
    setListName('')
    onClose()
  }, [setListName, onClose])

  const handleCreate = useCallback(() => {
    onCreate(listName)
  }, [listName, onCreate])

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setListName(event.target.value)
    },
    [],
  )

  return (
    <Dialog
      show={isOpen}
      onClose={handleClose}
    >
      <Dialog.Header>
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description className="text-center">
          {description}
        </Dialog.Description>
      </Dialog.Header>
      <div className="mt-6">
        <label
          htmlFor={FIELD_ID}
          className="text-sm font-medium text-text-default"
        >
          Name
        </label>
        <TextField
          id={FIELD_ID}
          value={listName}
          onChange={handleChange}
          placeholder={placeholder}
        />
      </div>
      <Dialog.ClosableFooter onClose={handleClose}>
        <Button
          onClick={handleCreate}
          isLoading={false}
          disabled={!listName}
        >
          Create List
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
